const autoNgTemplateLoaderTemplate1 = require('./volumesCifsForm.html');

angular.module('portainer.docker').component('volumesCifsForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    data: '=',
  },
});
